import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=d8067d9a&scoped=true&"
import script from "./Skills.vue?vue&type=script&lang=js&"
export * from "./Skills.vue?vue&type=script&lang=js&"
import style0 from "./Skills.vue?vue&type=style&index=0&id=d8067d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8067d9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8067d9a')) {
      api.createRecord('d8067d9a', component.options)
    } else {
      api.reload('d8067d9a', component.options)
    }
    module.hot.accept("./Skills.vue?vue&type=template&id=d8067d9a&scoped=true&", function () {
      api.rerender('d8067d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/SystemFieldForm/components/Skills.vue"
export default component.exports